module.exports = __webpack_public_path__ + "img/q_43_sor.cc43edaf.png";